import React, { useState } from "react";
import {
  Box,
  CssBaseline,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Drawer,
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Menu,
  Avatar,
  Dialog,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import MailIcon from "@mui/icons-material/Mail";
import { Outlet, useNavigate } from "react-router-dom";
import DashboardIcon from "@mui/icons-material/Dashboard";
import { getUserFromStorage } from "../../utils/auth";
import { useDispatch } from "react-redux";
import { logoutThunk } from "../../redux/slices/userSlice";

const drawerWidth = 200;

function PartnerDashboardPage() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();
  const session = getUserFromStorage();
  const user = session?.user;
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [openlogoutbox, setOpenlogoutbox] = useState(false);
  const dispatch = useDispatch();

  const handleOpenlogout = () => {
    setOpenlogoutbox(true);
  };
  const handleCloselogout = () => {
    setOpenlogoutbox(false);
  };

  const confirmLogout = async () => {
    const logout = await dispatch(logoutThunk());
    if (logout?.payload?.success) {
      navigate("/login");
    }

    setOpenlogoutbox(false);
  };

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleNavigation = (path) => {
    navigate(path);
    setMobileOpen(false);
  };

  const drawer = (
    <div>
      <Toolbar />
      <Divider />
      <List
        sx={{
          display: "flex",
          flexDirection: "column",
          p: 0,
          pl: -3,
        }}
      >
        {["DashbBoard", "Leads", "Deals", "Profile", "Withdrawal History"].map(
          (text, index) => (
            <ListItem
              key={text}
              disablePadding
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <ListItemButton
                onClick={() =>
                  handleNavigation(
                    text === "DashbBoard"
                      ? "/partner/dashboard"
                      : text === "Profile"
                      ? "/partner/dashboard/profile"
                      : text === "Deals"
                      ? "/partner/dashboard/my-deals"
                      : text === "Leads"
                      ? "/partner/dashboard/my-leads"
                      : text === "Withdrawal History"
                      ? "/partner/dashboard/withdrawal-history"
                      : `/admin-dashboard/${text
                          .toLowerCase()
                          .replace(/\s/g, "-")}`
                  )
                }
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: "40px",
                  }}
                >
                  {index % 2 === 0 ? <DashboardIcon /> : <MailIcon />}
                </ListItemIcon>

                <ListItemText
                  primary={text}
                  sx={{
                    whiteSpace: "nowrap",
                  }}
                />
              </ListItemButton>
            </ListItem>
          )
        )}
      </List>
    </div>
  );

  return (
    <>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        {/* AppBar */}
        <AppBar
          position="fixed"
          sx={{
            zIndex: (theme) => theme.zIndex.drawer + 1,
            width: { sm: `calc(100% - ${drawerWidth}px)` },
            ml: { sm: `${drawerWidth}px` },
          }}
        >
          <Toolbar>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              {/* Left Section */}
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <IconButton
                  color="inherit"
                  aria-label="open drawer"
                  edge="start"
                  onClick={handleDrawerToggle}
                  sx={{ mr: 2, display: { sm: "none" } }}
                >
                  <MenuIcon />
                </IconButton>
                <Typography variant="h6" noWrap>
                  Partner Dashboard
                </Typography>
              </Box>

              {/* Right Section */}
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <IconButton onClick={handleMenuClick} sx={{ p: 0 }}>
                  <Avatar alt="Profile Picture">
                    {user?.firstName?.charAt(0)}
                  </Avatar>
                </IconButton>

                <Menu
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  transformOrigin={{ vertical: "top", horizontal: "right" }}
                >
                  <MenuItem
                    onClick={() => {
                      handleClose();
                      navigate("/partner/dashboard/profile");
                    }}
                  >
                    Profile
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      handleClose();
                      handleOpenlogout();
                    }}
                  >
                    Logout
                  </MenuItem>
                </Menu>
              </Box>
            </Box>
          </Toolbar>
        </AppBar>

        {/* Drawer */}
        <Box
          component="nav"
          sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
          aria-label="mailbox folders"
        >
          {/* Temporary Drawer for mobile */}
          <Drawer
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              display: { xs: "block", sm: "none" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: drawerWidth,
              },
            }}
          >
            {drawer}
          </Drawer>
          <Drawer
            variant="permanent"
            sx={{
              display: { xs: "none", sm: "block" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: drawerWidth,
              },
            }}
            open
          >
            {drawer}
          </Drawer>

          {/* Permanent Drawer for desktop */}
          <Drawer
            variant="permanent"
            sx={{
              display: { xs: "none", sm: "block" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: drawerWidth,
              },
            }}
            open
          >
            {drawer}
          </Drawer>
        </Box>

        {/* Main Content */}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            // p: 3,
            width: { xs: "100%", sm: `calc(100% - ${drawerWidth}px)` },
            ml: { sm: `${drawerWidth}px` },
          }}
        >
          <Toolbar />
        </Box>
      </Box>
      {/* logout dialog */}
      <Dialog
        open={openlogoutbox}
        onClose={handleCloselogout}
        className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50"
      >
        <div className="bg-white p-6 rounded-xl shadow-lg w-80 text-center text-gray-800">
          <h3 className="text-lg font-semibold">Confirm Logout</h3>
          <p className="text-gray-600 mt-2">Are you sure you want to logout?</p>
          <div className="mt-4 flex justify-center gap-4">
            <button
              onClick={handleCloselogout}
              className="px-4 py-2 bg-gray-300 rounded-lg hover:bg-gray-400 transition duration-200"
            >
              Cancel
            </button>
            <button
              onClick={confirmLogout}
              className="px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition duration-200"
            >
              Logout
            </button>
          </div>
        </div>
      </Dialog>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 1,
          ml: { sm: `${drawerWidth}px` },
          width: { sm: `calc(100% - ${drawerWidth}px)` },
        }}
      >
        {/* <Toolbar /> */}
        <Outlet />
      </Box>
    </>
  );
}

export default PartnerDashboardPage;
